module.exports = __webpack_public_path__ + "img/cube.b3891ab0.png";